
import { oz } from '@weft/utils';

export const BILLING_INTERVALS = Object.freeze({
  Monthly: 'Monthly',
  BiMonthly: 'BiMonthly',
  Quarterly: 'Quarterly',
  SixMonths: 'SixMonths',
  Yearly: 'Yearly',
});

export const BillingIntervalSchema = oz.nativeEnum(BILLING_INTERVALS).openapi('BillingInterval');

export type BillingInterval = oz.infer<typeof BillingIntervalSchema>;